import client from "./client";

const BASE = "/tasks";

export const listTasks = async (params = {}) => (await client.get(BASE, { params })).data;
export const taskStats = async (params = {}) => (await client.get(`${BASE}/stats`, { params })).data;
export const getTask = async (id) => (await client.get(`${BASE}/${id}`)).data;
export const createTask = async (body) => (await client.post(BASE, body)).data;
export const updateTask = async (id, body) => (await client.patch(`${BASE}/${id}`, body)).data;
export const deleteTask = async (id) => (await client.delete(`${BASE}/${id}`)).data;
export const setTaskProgress = async (id, progress) =>
  (await client.post(`${BASE}/${id}/progress`, { progress })).data;
export const completeTask = async (id, note) => (await client.post(`${BASE}/${id}/complete`, { note })).data;
export const approveTask = async (id, note) => (await client.post(`${BASE}/${id}/approve`, { note })).data;
export const rejectTask = async (id, note) => (await client.post(`${BASE}/${id}/reject`, { note })).data;
